import React, {useEffect, useState} from 'react'
import {Row, Col, Card, Table, Spin, message} from 'antd'
import {
  UsergroupAddOutlined,
  UserOutlined,
  CodeSandboxOutlined,
  PropertySafetyOutlined,
  CheckCircleOutlined,
  SafetyCertificateOutlined,
  FileDoneOutlined,
  CodepenOutlined,
} from '@ant-design/icons'
import Layouts from '../../components/Layouts'
import apiRequest from '../../hooks/ApiRequest'
import {formatAmount} from '../../hooks/Encryption'
import InsurerPerformanceTable from '../../components/InsrurerPerformance'

const PremiumSummaryList = () => {
  const [masterBrokers, setMasterBrokers] = useState([])
  const [selectedMasterBrokerId, setSelectedMasterBrokerId] = useState(null)
  const [selectedUnderWriterId, setSelectedUnderWriterId] = useState(null)
  const [brokerInsurerData, setBrokerInsurerData] = useState([])
  const [loading, setLoading] = useState(false)
  const [insurerPerformance, setInsurerPerformance] = useState([])
  const [brokerPerformance, setBrokerPerformance] = useState([])
  const [underWriter, setUnderWriter] = useState([])
  const UserRole = JSON.parse(localStorage.getItem('user'))
  const loggedInUserID = localStorage.getItem('loggedInUserID')
  const loggedInInsurer = localStorage.getItem('insurerId')
  useEffect(() => {
    const fetchDashboardData = async () => {
      setLoading(true)
      try {
        let response
        if (UserRole?.role == 303) {
          response = await apiRequest(
            `${process.env.REACT_APP_BASE_URL}/Transaction/CreditControlDashboardUnderwriter/credit-control-dashboard/underwriter/${loggedInUserID}`,
            'GET',
          )
          setMasterBrokers(response.data?.masterBrokers || [])
        } else if (UserRole?.role == 304) {
          response = await apiRequest(
            `${process.env.REACT_APP_BASE_URL}/Transaction/CreditControlDashboardMasterBroker/credit-control-dashboard/masterBroker/${loggedInUserID}`,
            'GET',
          )
          const transformed = [
            {
              masterBrokerId: response.data.masterBrokerId,
              masterBrokerName: response.data.masterBrokerName,
              totalBrokers: response.data.totalBrokers,
              totalPolicies: response.data.totalPolicies,
              totalPayment: response.data.totalPayment,
              totalPremium: response.data.totalPremium,
              totalOutstanding: response.data.totalOutstanding,
              brokers: response.data.brokerStatisticsDetails || [],
            },
          ]
          setMasterBrokers(transformed)
        } else if (UserRole?.role == 305) {
          response = await apiRequest(
            `${process.env.REACT_APP_BASE_URL}/Transaction/CreditControlDashboardBroker/credit-control-dashboard/broker/${loggedInUserID}`,
            'GET',
          )
          setBrokerInsurerData(response.data || [])
        }
      } catch (error) {
        message.error('Failed to load dashboard data')
        console.error('Error fetching dashboard data:', error)
      } finally {
        setLoading(false)
      }
    }
    if (UserRole?.role == '308') {
      fetchInsurerPerformance()
    }
    if (UserRole?.role == '305') {
      fetchBrokerPerformance()
    }
    fetchDashboardData()
  }, [])
  const fetchInsurerPerformance = async () => {
    try {
      const fetchURL = `${process.env.REACT_APP_BASE_URL_INSURER}/api/Insurer/GetKPIsByInsurerId/${loggedInInsurer}`
      const GetUnderWriters = `${process.env.REACT_APP_BASE_URL_AUTH}/api/Auth/GetUserRelationship`
      const response = await apiRequest(fetchURL, 'GET')
      const GetUnderWritersData = await apiRequest(GetUnderWriters, 'POST', [
        loggedInUserID,
      ])
      setInsurerPerformance(response?.data)
      setUnderWriter(GetUnderWritersData?.data)
    } catch (error) {
      console.error('Error fetching quotations:', error)
    }
  }
  const fetchBrokerPerformance = async () => {
    try {
      const fetchURL = `${process.env.REACT_APP_BASE_URL}/Policy/GetBrokerPolicyStats?brokerId=${loggedInUserID}`
      const response = await apiRequest(fetchURL, 'GET')
      setBrokerPerformance(response?.data?.result)
    } catch (error) {
      console.error('Error fetching quotations:', error)
    }
  }

  useEffect(() => {
    const fecthData = async () => {
      const response = await apiRequest(
        `${process.env.REACT_APP_BASE_URL}/Transaction/CreditControlDashboardUnderwriter/credit-control-dashboard/underwriter/${selectedUnderWriterId}`,
        'GET',
      )
      setMasterBrokers(response.data?.masterBrokers || [])
    }
    if (UserRole?.role == 308 && selectedUnderWriterId) {
      fecthData()
    }
  }, [selectedUnderWriterId])
  const selectedMasterBroker = masterBrokers.find(
    broker => broker.masterBrokerId === selectedMasterBrokerId,
  )

  return (
    <div title="assets" className="ant-layout-content dashboard">
      <div className="dash-bg-white">
        <Row gutter={16}>
          <Col span={24}>
            <div className="section-top-heading">
              <h3 style={{color: '#0C1362', fontWeight: '600', fontSize: 20}}>
                Credit Control Summary
              </h3>
            </div>
          </Col>
        </Row>
      </div>

      <div className="dash-bg-white" style={{marginTop: 20}}>
        {UserRole?.role == '308' && insurerPerformance && (
          <>
            <Row gutter={[24, 24]} justify="center">
              <Col xs={24} sm={24} md={12}>
                <div className="premium-summary-header">
                  <FileDoneOutlined className="header-icon" />
                  Insurer Performance
                </div>
                <Card className="premium-card">
                  <div className="premium-header-row">
                    <span>Total Policies Issued</span>
                    <span>Premium Collected</span>
                  </div>
                  <div className="premium-value-row">
                    <span className="collected-amount">
                      {insurerPerformance?.totalPoliciesIssues}
                    </span>
                    <span className="written-amount">
                      {insurerPerformance?.totalPremiumCollected}
                    </span>
                  </div>
                </Card>
              </Col>
              <Col xs={24} sm={24} md={12}>
                <div className="premium-summary-header">
                  <FileDoneOutlined className="header-icon" />
                  Claim Summary
                </div>
                <Card className="premium-card">
                  <div className="premium-header-row">
                    <span>Filed Claims</span>
                    <span>Settled Claims</span>
                    <span>Rejected Claims</span>
                    <span></span>
                  </div>
                  <div className="premium-value-row">
                    <span className="outstanding-amount">
                      {insurerPerformance?.claimSummery?.filedClaims}
                    </span>
                    <span className="collected-amount">
                      {insurerPerformance.claimSummery?.settledClaims}
                    </span>
                    <span className="outstanding-amount">
                      {insurerPerformance.claimSummery?.rejectedClaims}
                    </span>
                    <span></span>
                  </div>
                </Card>
              </Col>
            </Row>
            <Spin spinning={loading}>
              <>
                <div style={{margin: '40px 0 16px'}}>
                  <div className="premium-summary-header">
                    <SafetyCertificateOutlined className="header-icon" />
                    <span className="header-text">
                      Insurer-wise Premium Summary
                    </span>
                  </div>
                </div>
                {/* Show Broker Name once on top */}
                {/* <h3 style={{marginBottom: 20, color: '#0C1362'}}>
                  Broker: {brokerInsurerData?.brokerName}
                </h3>
                <Row gutter={[24, 24]} justify="center">
                  {brokerInsurerData?.groupedByInsurer?.map(insurer => (
                    <Col xs={24} sm={24} md={8} key={insurer.insurerId}>
                      <Card className="premium-card">
                        <div className="premium-name">
                          {insurer.insurerName}
                        </div>
                        <div className="premium-header-row">
                          <span>Total Policies</span>
                          <span>Total Premium</span>
                          <span>Total Payment</span>
                          <span>Outstanding</span>
                        </div>
                        <div className="premium-value-row">
                          <span>{insurer.totalPolicies}</span>
                          <span>{formatAmount(insurer.totalPremium)}</span>
                          <span>{formatAmount(insurer.totalPayment)}</span>
                          <span>{formatAmount(insurer.totalOutstanding)}</span>
                        </div>
                        <div className="premium-role">
                          Insurer{' '}
                          <PropertySafetyOutlined className="check-icon" />
                        </div>
                      </Card>
                    </Col>
                  ))}
                </Row> */}
              </>
              {/* === 303 & 304 === */}
              {/* {(UserRole?.role == 303 || UserRole?.role == 304) && ( */}
              <>
                {UserRole?.role == 308 && (
                  <>
                    <div className="premium-summary-header">
                      <UsergroupAddOutlined className="header-icon" />
                      <span className="header-text">Underwriter Overview</span>
                    </div>
                    <Row gutter={[24, 24]} justify="center">
                      {underWriter.map(broker => (
                        <Col xs={24} sm={24} md={12} key={broker.assigneeId}>
                          <Card
                            className={`premium-card ${
                              selectedUnderWriterId === broker.assigneeId
                                ? 'selected-card'
                                : ''
                            }`}
                            hoverable
                            onClick={() =>
                              setSelectedUnderWriterId(broker.assigneeId)
                            }>
                            <div className="premium-header">
                              <div className="premium-name">
                                {broker.assigneeName}
                              </div>
                              <div className="broker-summary">
                                <UserOutlined className="summary-icon" />
                                <span className="summary-number">
                                  {broker.totalBrokers}
                                </span>
                                <span className="summary-label">
                                  UnderWriter
                                </span>
                              </div>
                            </div>
                            <div className="premium-role">
                              Underwriter{' '}
                              <CodepenOutlined className="check-icon_master" />
                            </div>
                          </Card>
                        </Col>
                      ))}
                    </Row>
                  </>
                )}
                {masterBrokers?.length > 0 && (
                  <>
                    <div style={{margin: '40px 0 16px'}}>
                      <div className="premium-summary-header">
                        <UsergroupAddOutlined className="header-icon" />
                        <span className="header-text">
                          Master Broker Overview
                        </span>
                      </div>
                    </div>
                    <Row gutter={[24, 24]} justify="center">
                      {masterBrokers.map(broker => (
                        <Col
                          xs={24}
                          sm={24}
                          md={12}
                          key={broker.masterBrokerId}>
                          <Card
                            className={`premium-card ${
                              selectedMasterBrokerId === broker.masterBrokerId
                                ? 'selected-card'
                                : ''
                            }`}
                            hoverable
                            onClick={() =>
                              setSelectedMasterBrokerId(broker.masterBrokerId)
                            }>
                            <div className="premium-header">
                              <div className="premium-name">
                                {broker.masterBrokerName}
                              </div>
                              <div className="broker-summary">
                                <UserOutlined className="summary-icon" />
                                <span className="summary-number">
                                  {broker.totalBrokers}
                                </span>
                                <span className="summary-label">Broker</span>
                              </div>
                            </div>
                            <div className="premium-header-row">
                              <span>Total Policies</span>
                              <span>Total Payment</span>
                              <span>Total Premium</span>
                              <span>Total Outstanding</span>
                            </div>
                            <div className="premium-value-row">
                              <span>{broker.totalPolicies}</span>
                              <span>{formatAmount(broker.totalPayment)}</span>
                              <span>{formatAmount(broker.totalPremium)}</span>
                              <span>
                                {formatAmount(broker.totalOutstanding)}
                              </span>
                            </div>
                            <div className="premium-role">
                              Master Broker{' '}
                              <CodeSandboxOutlined className="check-icon_master" />
                            </div>
                          </Card>
                        </Col>
                      ))}
                    </Row>
                  </>
                )}

                {/* Brokers under selected Master Broker */}
                {selectedMasterBroker?.brokers?.length > 0 && (
                  <div style={{marginTop: 40}}>
                    <div className="premium-summary-header">
                      <UserOutlined className="header-icon" />
                      <span className="header-text">
                        {/* Brokers under {selectedMasterBroker.masterBrokerName} */}
                        Broker-wise Premium Summary
                      </span>
                    </div>

                    <Row gutter={[24, 24]} justify="center">
                      {selectedMasterBroker.brokers.map(broker => (
                        <Col xs={24} sm={24} md={8} key={broker.brokerId}>
                          <Card className="premium-card">
                            <div className="premium-name">
                              {broker.brokerName}
                            </div>
                            <div className="premium-header-row">
                              <span>Total Policies</span>
                              <span>Total Premium</span>
                              <span>Total Payment</span>
                              <span>Total Outstanding</span>
                            </div>
                            <div className="premium-value-row">
                              <span>{broker.totalPolicies}</span>
                              <span>{formatAmount(broker.totalPremium)}</span>
                              <span>{formatAmount(broker.totalCollected)}</span>
                              <span>
                                {formatAmount(broker.totalOutstanding)}
                              </span>
                            </div>
                            <div className="premium-role">
                              Broker{' '}
                              <CheckCircleOutlined className="check-icon" />
                            </div>
                          </Card>
                        </Col>
                      ))}
                    </Row>
                  </div>
                )}
              </>
              {/* )} */}

              {/* === 305 Broker Summary by Insurer === */}
              {/* {UserRole?.role == 305 && ( */}
              {/* <>
                <div style={{margin: '40px 0 16px'}}>
                  <div className="premium-summary-header">
                    <SafetyCertificateOutlined className="header-icon" />
                    <span className="header-text">
                      Insurer-wise Premium Summary
                    </span>
                  </div>
                </div> */}
              {/* Show Broker Name once on top */}
              {/* <h3 style={{marginBottom: 20, color: '#0C1362'}}>
                  Broker: {brokerInsurerData?.brokerName}
                </h3>
                <Row gutter={[24, 24]} justify="center">
                  {brokerInsurerData?.groupedByInsurer?.map(insurer => (
                    <Col xs={24} sm={24} md={8} key={insurer.insurerId}>
                      <Card className="premium-card">
                        <div className="premium-name">
                          {insurer.insurerName}
                        </div>
                        <div className="premium-header-row">
                          <span>Total Policies</span>
                          <span>Total Premium</span>
                          <span>Total Payment</span>
                          <span>Outstanding</span>
                        </div>
                        <div className="premium-value-row">
                          <span>{insurer.totalPolicies}</span>
                          <span>{formatAmount(insurer.totalPremium)}</span>
                          <span>{formatAmount(insurer.totalPayment)}</span>
                          <span>{formatAmount(insurer.totalOutstanding)}</span>
                        </div>
                        <div className="premium-role">
                          Insurer{' '}
                          <PropertySafetyOutlined className="check-icon" />
                        </div>
                      </Card>
                    </Col>
                  ))}
                </Row>
              </> */}
              {/* )} */}
            </Spin>
          </>
        )}
        {UserRole?.role == '305' && (
          <InsurerPerformanceTable data={brokerPerformance} />
        )}
        <Spin spinning={loading}>
          {/* === 303 & 304 === */}
          {(UserRole?.role == 303 || UserRole?.role == 304) && (
            <>
              <div className="premium-summary-header">
                <UsergroupAddOutlined className="header-icon" />
                <span className="header-text">Master Broker Overview</span>
              </div>

              <Row gutter={[24, 24]} justify="center">
                {masterBrokers.map(broker => (
                  <Col xs={24} sm={24} md={12} key={broker.masterBrokerId}>
                    <Card
                      className={`premium-card ${
                        selectedMasterBrokerId === broker.masterBrokerId
                          ? 'selected-card'
                          : ''
                      }`}
                      hoverable
                      onClick={() =>
                        setSelectedMasterBrokerId(broker.masterBrokerId)
                      }>
                      <div className="premium-header">
                        <div className="premium-name">
                          {broker.masterBrokerName}
                        </div>
                        <div className="broker-summary">
                          <UserOutlined className="summary-icon" />
                          <span className="summary-number">
                            {broker.totalBrokers}
                          </span>
                          <span className="summary-label">Broker</span>
                        </div>
                      </div>
                      <div className="premium-header-row">
                        <span>Total Policies</span>
                        <span>Total Payment</span>
                        <span>Total Premium</span>
                        <span>Total Outstanding</span>
                      </div>
                      <div className="premium-value-row">
                        <span>{broker.totalPolicies}</span>
                        <span>{formatAmount(broker.totalPayment)}</span>
                        <span>{formatAmount(broker.totalPremium)}</span>
                        <span>{formatAmount(broker.totalOutstanding)}</span>
                      </div>
                      <div className="premium-role">
                        Master Broker{' '}
                        <CodeSandboxOutlined className="check-icon_master" />
                      </div>
                    </Card>
                  </Col>
                ))}
              </Row>

              {/* Brokers under selected Master Broker */}
              {selectedMasterBroker?.brokers?.length > 0 && (
                <div style={{marginTop: 40}}>
                  <div className="premium-summary-header">
                    <UserOutlined className="header-icon" />
                    <span className="header-text">
                      {/* Brokers under {selectedMasterBroker.masterBrokerName} */}
                      Broker-wise Premium Summary
                    </span>
                  </div>

                  <Row gutter={[24, 24]} justify="center">
                    {selectedMasterBroker.brokers.map(broker => (
                      <Col xs={24} sm={24} md={8} key={broker.brokerId}>
                        <Card className="premium-card">
                          <div className="premium-name">
                            {broker.brokerName}
                          </div>
                          <div className="premium-header-row">
                            <span>Total Policies</span>
                            <span>Total Premium</span>
                            <span>Total Collected</span>
                            <span>Total Outstanding</span>
                          </div>
                          <div className="premium-value-row">
                            <span>{broker.totalPolicies}</span>
                            <span>{formatAmount(broker.totalPremium)}</span>
                            <span>{formatAmount(broker.totalCollected)}</span>
                            <span>{formatAmount(broker.totalOutstanding)}</span>
                          </div>
                          <div className="premium-role">
                            Broker{' '}
                            <CheckCircleOutlined className="check-icon" />
                          </div>
                        </Card>
                      </Col>
                    ))}
                  </Row>
                </div>
              )}
            </>
          )}

          {/* === 305 Broker Summary by Insurer === */}
          {UserRole?.role == 305 && (
            <>
              <div style={{margin: '40px 0 16px'}}>
                <div className="premium-summary-header">
                  <SafetyCertificateOutlined className="header-icon" />
                  <span className="header-text">
                    Broker Premium Summary
                  </span>
                </div>
              </div>
              {/* Show Broker Name once on top */}
              <h3 style={{marginBottom: 20, color: '#0C1362'}}>
                Broker: {brokerInsurerData?.brokerName}
              </h3>
              <Row gutter={24} type="flex" justify="start">
                {brokerInsurerData?.groupedByInsurer?.map(insurer => (
                  <Col
                    key={insurer.insurerId}
                    xs={24}
                    sm={24}
                    md={12} // 2 per row on medium screens (≥768px)
                    lg={12} // still 2 per row on large screens (≥992px)
                    xl={8} // 3 per row only on extra large screens (≥1200px)
                    style={{marginBottom: 24}}>
                    <Card className="premium-card">
                      <div className="premium-name">{insurer.insurerName}</div>

                      <div className="premium-header-row">
                        <span>Total Policies</span>
                        <span>Total Premium</span>
                        <span>Total Payment</span>
                        <span>Outstanding</span>
                      </div>

                      <div className="premium-value-row">
                        <span>{insurer.totalPolicies}</span>
                        <span>{formatAmount(insurer.totalPremium)}</span>
                        <span>{formatAmount(insurer.totalPayment)}</span>
                        <span>{formatAmount(insurer.totalOutstanding)}</span>
                      </div>

                      <div className="premium-role">
                        Insurer{' '}
                        <PropertySafetyOutlined className="check-icon" />
                      </div>
                    </Card>
                  </Col>
                ))}
              </Row>
            </>
          )}

          {/* === Optional Underwriter Summary Table for 303 === */}
          {/* {UserRole?.role == 303 && (
            <div style={{margin: '40px 0'}}>
              <div className="premium-summary-header">
                <PropertySafetyOutlined className="header-icon" />
                <span className="header-text">
                  Underwriter Premiums Summary
                </span>
              </div>
              <Table
                columns={[
                  {title: 'Name', dataIndex: 'name', key: 'name'},
                  {
                    title: 'Premium Written',
                    dataIndex: 'written',
                    key: 'written',
                  },
                  {
                    title: 'Collected',
                    dataIndex: 'collected',
                    key: 'collected',
                  },
                  {
                    title: 'Outstanding',
                    dataIndex: 'outstanding',
                    key: 'outstanding',
                  },
                ]}
                dataSource={[]} // You can plug in underwriter summary data here if available
                rowKey="id"
                pagination={false}
                style={{marginTop: 20}}
              />
            </div>
          )} */}
        </Spin>
      </div>
    </div>
  )
}

export default PremiumSummaryList
